"use client";

import { useEffect, useState } from "react";

import { useResponsiveValue } from "../../../_hooks/use-responsive-value";

export const AVAILABILITY_STRIP_RANGE_SIZE = { sp: 7, pc: 14 } as const;

/**
 * AvailabilityStrip の表示週日数。既存の `useResponsiveValue` (lg=1024px) を使うことで、
 * Provider（表示週の中央配置計算）とセルグリッド描画側で判定ロジックを共有する。
 *
 * `useResponsiveValue` は mount 直後は base 値を返し、内部の `useLayoutEffect` で実際の
 * breakpoint 値に更新する2段階の値変化をする。isRangeSizeResolved は自身の `useEffect` で
 * true にするため、useLayoutEffect が同一コミット内で必ず先に走ることを利用して
 * 「rangeSize が確定値になったタイミング」を呼び出し元に伝える。
 */
export function useAvailabilityStripRangeSize(): {
  rangeSize: number;
  isRangeSizeResolved: boolean;
} {
  const rangeSize = useResponsiveValue({
    base: AVAILABILITY_STRIP_RANGE_SIZE.sp,
    lg: AVAILABILITY_STRIP_RANGE_SIZE.pc,
  });
  const [isRangeSizeResolved, setIsRangeSizeResolved] = useState(false);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- mount後にrangeSize確定を通知するフラグパターン
    setIsRangeSizeResolved(true);
  }, []);
  return { rangeSize, isRangeSizeResolved };
}
